@use "@fukuri-admins/ui/layout" as *;

.root {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: spacing("8");
}

.header {
  display: flex;
  gap: spacing("8");
  align-items: baseline;
}

.label {
  color: text("High");

  @include typography("Jp/20_W6");
}

.stats {
  display: flex;
  gap: spacing("8");
  align-items: baseline;
}

.rate {
  color: text("Middle");

  @include typography("Jp/20_W6");
}

.detail {
  color: text("Low");

  @include typography("Jp/14_W3");
}

.progressBar {
  max-width: 368px;
  height: 24px;
  background: background("Secondary");
  border-radius: borderRadius("sm");
  overflow: hidden;
}

.progressFill {
  height: 100%;
  background: background("Green_Darken");
  border-radius: borderRadius("sm");
  transition: width 0.3s ease;
}
